@if (make() && model()) {
  <div class="container">
    <p>
      {{
        makeDictionaryCode()
          ? (`${makeDictionaryCode()}.${make()}` | translate)
          : make()
      }}
    </p>

    <p class="f-body-s f-muted">
      {{
        modelDictionaryCode()
          ? (`${modelDictionaryCode()}.${model()}` | translate)
          : model()
      }}
    </p>
  </div>
} @else {
  -
}
